"use client";
import { DeleteCart, EditCart, getCartItem } from "@/API/response";
import { deleteCart, getCartItemStart, getCartItemSuccess, updateCart } from "@/GlobalRedux/Slices/allCartItems";
import { toggleDrawer } from "@/GlobalRedux/Slices/drawerCart";
import { getSessionId } from "@/utils/session";
import { Button, Dialog, Drawer, IconButton, Typography } from "@material-tailwind/react";
import Link from "next/link";
import React, { useEffect } from "react";
import { FaMinus, FaPlus, FaRegTrashAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
const CartDrawer = ({ openDrawer, closeDrawer, cartData, loader }) => {
  // console.log("cartData",cartData)
  const dispatch = useDispatch()
  // edit cart quantity
  const handleIncrement = async (item) => {
    try {
      const newQuantity = item?.quantity + 1;
      let response = await EditCart(item?.productId._id, "cart/editCartItem", newQuantity);
      dispatch(updateCart({ productId: item?.productId._id, quantity: newQuantity }));
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };

  const handleDecrement = async (item) => {
    try {
      if (item.quantity > 1) {
        const newQuantity = item.quantity - 1;
        let response = await EditCart(item?.productId._id, "cart/editCartItem", newQuantity);
        dispatch(updateCart({ productId: item?.productId._id, quantity: newQuantity }));
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };
  // remove cart
  const handleRemoveFromCart = async (id) => {
    dispatch(deleteCart(id))
    try {
      const response = await DeleteCart(id, "cart/deleteCartItem")
    } catch (error) {
      console.log(error)
    }
  };
  const getCartProducts = async () => {
          const SessionId = getSessionId()
          try {
            dispatch(getCartItemStart())
            const response = await getCartItem("cart/getCart", SessionId);
            dispatch(getCartItemSuccess(response.items))
          } catch (error) {
            console.log(error)
          }
        }
      
        useEffect(() => {
            getCartProducts()
        }, [])

  return (
    <Drawer
      placement="right"
      open={openDrawer}
      onClose={closeDrawer}
      overlayProps={{
        className: "absolute  inset-0 w-full pointer-events-auto !h-full pointer-events-auto z-[9995] bg-gray-800 bg-opacity-0 backdrop-blur-none"
      }}
      className={" p-4  bg-white !h-full custom-scrollbar  !max-h-screen overflow-y-auto   !w-[300px] !md:w-[600px]"}
    >
      {/* Drawer Header */}
      <div className="mb-4 flex items-center justify-between">
        <Typography variant="h5" color="blue-gray">
          Your Cart
        </Typography>
        <IconButton variant="text" color="blue-gray" onClick={closeDrawer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </IconButton>
      </div>

      {/* Loader */}
      {loader ? (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="space-y-4">
          {/* Cart Items */}
          {cartData && cartData?.items?.length > 0 ? (
            cartData?.items?.map((item, index) => (
              <div key={index} className="flex flex-col  justify-between p-3 bg-gray-100 rounded-lg">
                <div className="flex justify-between">
                  <img src={item?.productId?.images[0]} className="w-20 h-20" alt="" />
                  <div className="flex items-center gap-4 mt-4">
                    <button onClick={() => handleDecrement(item)} className="p-2 bg-gray-200 rounded-full">
                      <FaMinus />
                    </button>
                    <span className="mx-2.5">{item?.quantity >= 5 ? 5 : item?.quantity}</span>
                    <button 
                    onClick={item?.quantity>=5 ? undefined:() => handleIncrement(item)} 
                    className={`p-2 bg-gray-200 rounded-full ${item?.quantity >= 5 ? "cursor-not-allowed opacity-50" : ""}`}
                    disabled={item?.quantity >= 5}
                    >
                      <FaPlus />
                    </button>
                  </div>
                  <span>
                    <FaRegTrashAlt onClick={() => handleRemoveFromCart(item?.productId?._id)} className="hover:cursor-pointer text-red-500" />
                  </span>
                </div>
                <div>
                  <Typography variant="small" className="py-3" color="blue-gray">
                    {item?.productId?.name.slice(0, 40)}..
                  </Typography>
                </div>
                <div className="flex justify-between">
                  <Typography variant="normal" className="text-md font-bold" color="gray">
                  RS: {item?.productId?.price * (item?.quantity >= 5 ? 5 : item?.quantity)}
                  </Typography>
                  <Typography variant="small" className="text-sm font-bold" color="blue-gray">
                    x{item?.quantity >= 5 ? 5 : item?.quantity}
                  </Typography>
                </div>
              </div>
            ))
          ) : (
            <Typography color="gray" className="flex flex-col items-center text-lg font-bold justify-center h-[70vh] w-full text-center mt-4">
              Your cart is empty.
              <img src="/Images/empty-cart.png" className="h-20 w-20 " alt="" />
            </Typography>
          )}
        </div>
      )}

      {/* Checkout Button */}
      {!loader && cartData?.items?.length > 0 && (
        <div className="mt-6 flex gap-3 ">
         
          <Button variant="outlined" onClick={()=>{ dispatch(toggleDrawer())}}  className=" text-darkBlack" color="green">
            Continue Shopping
          </Button>
          <Link href={'/addCart'}>
          <Button onClick={()=>{ dispatch(toggleDrawer())}}   className="bg-black text-pureWhite" color="blue">
            Proceed to Checkout
          </Button>
          </Link>

        </div>
      )}
    </Drawer>

  );
};

export default CartDrawer;
